<template>
  <div>
    <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 582px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <div>
        <span style="font-size:20px; color: #fff; font-weight: 600;">5 Top จุดติดตั้งกล้องสูงสุด</span>
      </div>

      <b-row
        v-for="(item, index) in progress.slice(0,5)"
        :key="index"
        style="margin-top: 25px"
      >
        <b-col lg="10">
          <label style="color: #ffffff; font-size: 18px;">{{ index + 1 + '. ' }} {{ item.name }}</label>
          <b-progress
            :value="item.value"
            max="500"
            precision="2"
            class="progress8"
          />
        </b-col>
        <b-col
          lg="2"
          style="text-align: left;"
        >
          <br>
          <span style="color:#ffffff;">{{ item.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} กล้อง</span>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BProgress, BCard,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  name: 'TopCCTVLocations',
  components: {
    BRow,
    BCol,
    BProgress,
    BCard,
  },
  data() {
    return {
      progress: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getPieData()
    this.interval = setInterval(() => {
      this.getPieData()
    }, 300000)
  },
  methods: {
    getPieData() {
      axios
        .post('/getPercentCCTVTotal', {
          department: this.userData.department,
          username: this.userData.username,
        })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.progress = response.data[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

  <style lang="scss" scoped>
  .progress8 .progress-bar {
    background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%);
  }
  </style>
